// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorChunkedUploads = (client) => ({
    /**
     * `POST /vendor/chunked-uploads/:uploadId/complete`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorChunkedUploadsComplete
     * @source apps/backend/src/api/vendor/chunked-uploads/[uploadId]/complete/route.ts
     */
    complete: (uploadId, body, query, headers) => client.fetch(buildPath("/vendor/chunked-uploads/:uploadId/complete", [uploadId]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/chunked-uploads`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorChunkedUploadsInit
     * @source apps/backend/src/api/vendor/chunked-uploads/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/chunked-uploads", { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/chunked-uploads/:uploadId`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorChunkedUploadsAbort
     * @source apps/backend/src/api/vendor/chunked-uploads/[uploadId]/route.ts
     */
    delete: (uploadId, body, query, headers) => client.fetch(buildPath("/vendor/chunked-uploads/:uploadId", [uploadId]), { method: "DELETE", body, query, headers }),
    /**
     * `PUT /vendor/chunked-uploads/:uploadId/chunks/:chunkIndex`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorChunkedUploadsPutChunk
     * @source apps/backend/src/api/vendor/chunked-uploads/[uploadId]/chunks/[chunkIndex]/route.ts
     */
    updateChunk: (uploadId, chunkIndex, body, query, headers) => client.fetch(buildPath("/vendor/chunked-uploads/:uploadId/chunks/:chunkIndex", [uploadId, chunkIndex]), { method: "PUT", body, query, headers }),
});
//# sourceMappingURL=chunked-uploads.js.map